import React from 'react';
import Img from '../components/Img';
import styled from 'styled-components';

import img_main from '../assets/img/PC1-6.png';
import img_main_sm from '../assets/img/1-6.png';
import useWindowMatchMedia from '../utils/useWindowMatchMedia';
import {breakPoint} from '../styles/var';

const ContentStyles = styled.div`
  background-color: var(--bg);
  padding-bottom: 2rem;
  @media (max-width: ${breakPoint.smMax}) {
    padding-bottom: 1rem;
  }
`;


const Kvad = (props) => {
  const isMedium = useWindowMatchMedia(breakPoint.min);
  return <ContentStyles {...props}>
    { isMedium ? <Img src={img_main} auto/> : <Img src={img_main_sm} auto /> }
  </ContentStyles>
};

export default Kvad;
